import { Typography } from '@mui/material';
import { GlobalStyles } from '@shared/theme';
import SearchIllustration from '@ui/SVGIllustration/library/SearchIllustration';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import ExternalPageCard from '../ExternalPageCard';

const NotFound = ({ children }: { children: ReactNode }) => (
  <ExternalPageCard>
    <GlobalStyles backgroundColor={(palette) => palette.neutrals[400]} />
    <SearchIllustration height={130} />
    <Typography variant="subtitle1" component="h1">
      <FormattedMessage id="page_not_found.title" />
    </Typography>
    <Typography variant="body2">
      <FormattedMessage id="page_not_found.message" />
    </Typography>
    {/* doubles the gap */}
    {children && <div />}
    {children}
  </ExternalPageCard>
);

export default NotFound;
